module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "numbert"
  }, [_vm._v("1. "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Plan your week on Sunday night.")]), _vm._v(" You don’t need to come up with a detailed hour-by-hour schedule, but spending a few minutes on the weekend planning what you hope to accomplish during the week can be a great way to set yourself up for success come Monday morning. Divide the responsibilities you have for the week onto specific days. This practice will give you a good idea of what your workweek will look like, and it will help you know whether or not you have time to take on additional projects.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Prep, prep, prep.")]), _vm._v(" Before you go to bed each night, set yourself up for success in the morning by prepping things you’ll need when you wake up. This can be as simple as laying out your outfit for the next day and putting your workbag by the door, or as involved as planning out exactly what time you aim to do each part of your routine and grinding beans for your morning cup of joe. When you wake up groggy in the morning, you’ll thank yourself for making things a little easier.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("3. ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Start the day with water.")]), _vm._v(" Your first instinct in the morning might be to reach for a cup of coffee, but you’re much better off if you reach for a glass of water instead. When you first wake up, you’re often dehydrated because you spent the whole night not consuming any fluids. Add a cup of coffee on top of that, and you’re actually becoming more dehydrated, thanks to the diuretic effect of all that much-needed caffeine—making it even harder for your body to get going. Kick things off with a big glass of water in the morning before making the switch to coffee—you’ll feel refreshed and get your day off to a much better start.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("4. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Eat breakfast.")]), _vm._v(" You know how your mom always told you that breakfast is the most important meal of the day? She was right. Having breakfast jump-starts your metabolism and lets your body know that it’s time to get things done. Beyond helping you wake up and ease into the day, a good breakfast will give you the energy you need to be productive in the morning, and it will help keep your mind off food until lunchtime.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("5. ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Keep your alarm clock away from the bed so you can’t hit that snooze button.")]), _vm._v(" You may think you’re getting some much-needed extra sleep with those five more minutes in dreamland, but you’re actually resetting yourself to the beginning of your sleep cycle, which means you’ll be even more tired when you do get out of bed. Snoozing also takes time away that you could be using to handle your morning routine. Those minutes could be used for a quick breakfast that you usually don’t have time for!")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("6. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Schedule a weekly or biweekly “maintenance day” where you say no to additional commitments and instead focus on tasks you need to finish for your home.")]), _vm._v(" You can use this day to tidy up your home, pay bills, do laundry . . . anything you need to set yourself up to be successful. For instance, you might assign the first and last Sunday of the month as “maintenance days.” When you know you have a maintenance day coming up, it’s much easier to prioritize other commitments during the week without that stress about a home project.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("7. ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Create a visual “chain” of consistency.")]), _vm._v(" Back when Jerry Seinfeld was a touring comic, he used a calendar system called “Don’t break the chain.” He marked each day on a calendar that he worked toward a goal. As you mark the days, you will not only track your progress but also appreciate the daily work you have put into your aspirations. After a while you’ll have a long “chain” of days where you’ve completed a specific task or taken another step toward your goals. The aim here is to not “break the chain” by not missing days along the way.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("8. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Kick-start the morning with exercise.")]), _vm._v(" Exercising in the morning can be a quick way to get your blood moving and your brain awake and ready for action. You don’t have to go to the gym for a full-on early morning workout, but even something as simple as a fifteen-minute run around your neighborhood or a brief cardio routine at home is enough to get your heart rate up and let your body know that it’s time to be up and moving.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47575d8d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01a.vue
// module id = 75
// module chunks = 0